import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { SettingsPageRow } from './SettingsPageRow';
import { SETTINGS_PAGE_MAX_WIDTH } from '../../constants/uiConsts';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
    },
    main: {
      maxWidth: SETTINGS_PAGE_MAX_WIDTH,
      width: '100%',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: theme.spacing(4),
      width: '100%',
    },
    toolbarActionsWrapper: {
      width: 300,
      display: 'flex',
      justifyContent: 'right',
    },
  }),
);

export const ModuleContainer: React.FC<{
  description: React.ReactNode;
  toolbarActions: React.ReactNode;
}> = ({ children, description, toolbarActions }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.main}>
        <SettingsPageRow
          fullHeight
          description={
            <div className={classes.header}>
              {description}
              <div className={classes.toolbarActionsWrapper}>
                {toolbarActions}
              </div>
            </div>
          }
        >
          {children}
        </SettingsPageRow>
      </div>
    </div>
  );
};
